export { default as Documents } from './Documents';
